import { formatPrice as e } from "@frontends/util-utils";
import { createContext as t, useCallback as n, useContext as r, useEffect as i, useLayoutEffect as a, useMemo as o, useRef as s, useState as c } from "react";
import { useTheme as l } from "@frontends/util-theme-provider";
import { FALLBACK_LANGUAGE as u, useLocale as d } from "@frontends/util-i18n";
import { createInstance as ee } from "i18next";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
import { toWidgetLocale as m } from "@frontends/feature-charting-library";
import { getSymbolIconUrl as h } from "@frontends/util-symbol-icons";
import { createWsConnection as g } from "@frontends/util-ws";
//#region src/document-title/updateDocumentTitle.ts
function _({ applicationTitle: t, locale: n, quote: r, symbolInfo: i, symbolName: a }) {
	let o = i?.library_custom_fields?.digits;
	if (!a || !r || !i || typeof o != "number" || !Number.isInteger(o) || o < 0) return;
	let { chp: s = 0, lp: c = 0 } = r.v, l = "", u = "";
	s > 0 && (l = "▲", u = `+${s.toFixed(2)}%`), s < 0 && (l = "▼", u = `${s.toFixed(2)}%`);
	let d = `${a} ${e(c, o, n)} ${l} ${u} ${t}`;
	document.title !== d && (document.title = d);
}
//#endregion
//#region src/loading/GlobalLoadingContext.ts
var v = t(null), y = {
	loadErrorDescription: "حدث خطأ أثناء تحميل التطبيق. يرجى المحاولة مرة أخرى.",
	loadErrorRetry: "إعادة المحاولة",
	loadErrorTitle: "فشل التحميل",
	loading: "جارٍ التحميل…",
	lots: "لوت",
	points: "النقاط"
}, b = {
	loadErrorDescription: "Beim Laden der Anwendung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
	loadErrorRetry: "Erneut versuchen",
	loadErrorTitle: "Laden fehlgeschlagen",
	loading: "Wird geladen…",
	lots: "Lots",
	points: "Punkte"
}, x = {
	loadErrorDescription: "Something went wrong while loading the application. Please try again.",
	loadErrorRetry: "Retry",
	loadErrorTitle: "Failed to load",
	loading: "Loading…",
	lots: "Lots",
	points: "Points"
}, S = {
	loadErrorDescription: "Algo salió mal al cargar la aplicación. Por favor, inténtalo de nuevo.",
	loadErrorRetry: "Reintentar",
	loadErrorTitle: "Error al cargar",
	loading: "Cargando…",
	lots: "Lotes",
	points: "Puntos"
}, C = {
	loadErrorDescription: "Une erreur est survenue lors du chargement de l'application. Veuillez réessayer.",
	loadErrorRetry: "Réessayer",
	loadErrorTitle: "Échec du chargement",
	loading: "Chargement…",
	lots: "Lots",
	points: "Points"
}, w = {
	loadErrorDescription: "Terjadi kesalahan saat memuat aplikasi. Silakan coba lagi.",
	loadErrorRetry: "Coba lagi",
	loadErrorTitle: "Gagal memuat",
	loading: "Memuat…",
	lots: "Lot",
	points: "Poin"
}, te = {
	loadErrorDescription: "アプリケーションの読み込み中にエラーが発生しました。もう一度お試しください。",
	loadErrorRetry: "再試行",
	loadErrorTitle: "読み込みに失敗しました",
	loading: "読み込み中…",
	lots: "ロット",
	points: "ポイント"
}, ne = {
	loadErrorDescription: "애플리케이션을 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요.",
	loadErrorRetry: "다시 시도",
	loadErrorTitle: "불러오기에 실패했습니다",
	loading: "불러오는 중…",
	lots: "랏",
	points: "포인트"
}, re = {
	loadErrorDescription: "Wystąpił błąd podczas ładowania aplikacji. Spróbuj ponownie.",
	loadErrorRetry: "Ponów",
	loadErrorTitle: "Nie udało się załadować",
	loading: "Ładowanie…",
	lots: "Loty",
	points: "Punkty"
}, ie = {
	loadErrorDescription: "Ocorreu um erro ao carregar a aplicação. Por favor, tente novamente.",
	loadErrorRetry: "Tentar novamente",
	loadErrorTitle: "Falha ao carregar",
	loading: "A carregar…",
	lots: "Lotes",
	points: "Pontos"
}, ae = {
	loadErrorDescription: "Что-то пошло не так при загрузке приложения. Пожалуйста, попробуйте снова.",
	loadErrorRetry: "Повторить",
	loadErrorTitle: "Не удалось загрузить",
	loading: "Загрузка…",
	lots: "Лоты",
	points: "Пункты"
}, oe = {
	loadErrorDescription: "เกิดข้อผิดพลาดขณะโหลดแอปพลิเคชัน กรุณาลองอีกครั้ง",
	loadErrorRetry: "ลองอีกครั้ง",
	loadErrorTitle: "โหลดไม่สำเร็จ",
	loading: "กำลังโหลด…",
	lots: "ล็อต",
	points: "คะแนน"
}, se = {
	loadErrorDescription: "Uygulama yüklenirken bir hata oluştu. Lütfen tekrar deneyin.",
	loadErrorRetry: "Tekrar dene",
	loadErrorTitle: "Yükleme başarısız",
	loading: "Yükleniyor…",
	lots: "Lot",
	points: "Puan"
}, ce = {
	loadErrorDescription: "Đã xảy ra lỗi khi tải ứng dụng. Vui lòng thử lại.",
	loadErrorRetry: "Thử lại",
	loadErrorTitle: "Không thể tải",
	loading: "Đang tải…",
	lots: "Lô",
	points: "Điểm"
}, le = {
	loadErrorDescription: "加载应用程序时出现问题。请重试。",
	loadErrorRetry: "重试",
	loadErrorTitle: "加载失败",
	loading: "加载中…",
	lots: "手",
	points: "点数"
}, T = "feature-tv-parts", ue = {
	"ar-SA": { [T]: y },
	"de-DE": { [T]: b },
	"en-GB": { [T]: x },
	"es-ES": { [T]: S },
	"fr-FR": { [T]: C },
	"id-ID": { [T]: w },
	"ja-JP": { [T]: te },
	"ko-KR": { [T]: ne },
	"pl-PL": { [T]: re },
	"pt-PT": { [T]: ie },
	"ru-RU": { [T]: ae },
	"th-TH": { [T]: oe },
	"tr-TR": { [T]: se },
	"vi-VN": { [T]: ce },
	"zh-CN": { [T]: le }
}, E = ee();
E.init({
	resources: ue,
	ns: [T],
	defaultNS: T,
	fallbackLng: u,
	load: "currentOnly",
	initAsync: !1,
	interpolation: { escapeValue: !1 }
});
//#endregion
//#region src/i18n/useTvPartsTranslation.ts
function D() {
	let { locale: e } = d();
	return o(() => E.getFixedT(e.language), [e.language]);
}
//#endregion
//#region src/helpers/isRecord.ts
function O(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region src/theme/palette.ts
var k = "#2962ff", A = {
	dark: {
		background: "#0F0F0F",
		textColor: "#dbdbdb"
	},
	light: {
		background: "#ffffff",
		textColor: "#1F1F1F"
	}
}, j = ["dark", "light"], M = ["#B8B8B8", "#0F0F0F"], N = new Set(Object.values(A).map(({ background: e }) => e.toUpperCase())), P = new Set([...Object.values(A).map(({ textColor: e }) => e), ...M].map((e) => e.toUpperCase()));
function F(e) {
	return N.has(e.toUpperCase());
}
function I(e) {
	return P.has(e.toUpperCase());
}
function L(e) {
	return typeof e == "string" ? j.find((t) => A[t].background.toUpperCase() === e.toUpperCase()) ?? null : null;
}
function R(e) {
	let { background: t, textColor: n } = A[e];
	return {
		"paneProperties.background": t,
		"paneProperties.backgroundType": "solid",
		"scalesProperties.textColor": n
	};
}
function z(e) {
	if (!O(e)) return !1;
	let { background: t, backgroundType: n } = e;
	return n && n !== "solid" ? !0 : typeof t == "string" && t !== "" && !F(t);
}
function B(e, t) {
	let n = V(e);
	if (n.some((e) => z(e))) return !1;
	let r = A[t].background.toUpperCase();
	return n.some((e) => {
		let t = U(e);
		return t !== null && t !== r;
	});
}
function V(e) {
	let t = "charts" in e ? e.charts : void 0;
	return Array.isArray(t) ? t.map(H) : [];
}
function H(e) {
	return O(e) && O(e.chartProperties) ? e.chartProperties.paneProperties : void 0;
}
function U(e) {
	return !O(e) || typeof e.background != "string" || e.background === "" ? null : e.background.toUpperCase();
}
//#endregion
//#region src/loading/screenColors.ts
var de = {
	dark: "#2e2e2e",
	light: "#f2f2f2"
};
function W(e) {
	let { background: t, textColor: n } = A[e];
	return {
		"--tv-parts-background": t,
		"--tv-parts-brand": k,
		"--tv-parts-text": n,
		"--tv-parts-track": de[e]
	};
}
var G = {
	screen: "_screen_8l0jz_1",
	fading: "_fading_8l0jz_9",
	spinner: "_spinner_8l0jz_14",
	spin: "_spin_8l0jz_14",
	label: "_label_8l0jz_28"
};
function fe({ isLoading: e }) {
	let [t, n] = c(e ? "visible" : "hidden"), { resolvedMode: r } = l(), a = D();
	if (e && t !== "visible" && n("visible"), i(() => {
		if (e || t === "hidden") return;
		let r = t === "visible" ? "fading" : "hidden", i = t === "visible" ? 100 : 200, a = window.setTimeout(() => n(r), i);
		return () => window.clearTimeout(a);
	}, [e, t]), t === "hidden") return null;
	let o = t === "fading", s = {
		...W(r),
		"--tv-parts-fade-out": "200ms"
	};
	return /* @__PURE__ */ p("div", {
		"aria-hidden": o ? !0 : void 0,
		className: o ? `${G.screen} ${G.fading}` : G.screen,
		role: "status",
		style: s,
		children: [/* @__PURE__ */ f("span", {
			"aria-hidden": "true",
			className: G.spinner
		}), /* @__PURE__ */ f("span", {
			className: G.label,
			children: a("loading")
		})]
	});
}
//#endregion
//#region src/loading/GlobalLoading.tsx
function pe({ children: e }) {
	let [t, r] = c(0), i = n(() => {
		let e = !1;
		return r((e) => e + 1), () => {
			e || (e = !0, r((e) => e - 1));
		};
	}, []);
	return /* @__PURE__ */ p(v.Provider, {
		value: i,
		children: [e, /* @__PURE__ */ f(fe, { isLoading: t > 0 })]
	});
}
var K = {
	loadError: "_loadError_1qrd7_1",
	page: "_page_1qrd7_16",
	overlay: "_overlay_1qrd7_22",
	message: "_message_1qrd7_28",
	title: "_title_1qrd7_34",
	description: "_description_1qrd7_38",
	retryButton: "_retryButton_1qrd7_43"
};
//#endregion
//#region src/loading/LoadError.tsx
function me() {
	window.location.reload();
}
function he({ layout: e = "page", title: t, description: n, showRetry: r = !0, onRetry: i = me }) {
	let { resolvedMode: a } = l(), o = D();
	return /* @__PURE__ */ p("div", {
		className: `${K.loadError} ${K[e]}`,
		style: W(a),
		children: [
			/* @__PURE__ */ p("svg", {
				"aria-hidden": "true",
				xmlns: "http://www.w3.org/2000/svg",
				viewBox: "0 0 24 24",
				width: "120",
				height: "120",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: "1",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				children: [
					/* @__PURE__ */ f("circle", {
						cx: "12",
						cy: "12",
						r: "10"
					}),
					/* @__PURE__ */ f("line", {
						x1: "12",
						y1: "8",
						x2: "12",
						y2: "12"
					}),
					/* @__PURE__ */ f("line", {
						x1: "12",
						y1: "16",
						x2: "12.01",
						y2: "16"
					})
				]
			}),
			/* @__PURE__ */ p("div", {
				className: K.message,
				role: "alert",
				children: [/* @__PURE__ */ f("div", {
					className: K.title,
					children: t ?? o("loadErrorTitle")
				}), /* @__PURE__ */ f("div", {
					className: K.description,
					children: n ?? o("loadErrorDescription")
				})]
			}),
			r && /* @__PURE__ */ f("button", {
				className: K.retryButton,
				type: "button",
				onClick: () => i(),
				children: o("loadErrorRetry")
			})
		]
	});
}
//#endregion
//#region src/loading/useGlobalLoading.ts
function ge() {
	let e = r(v);
	if (!e) throw Error("useGlobalLoading must be used within GlobalLoading");
	return e;
}
function _e(e) {
	let t = ge();
	a(() => {
		if (e) return t();
	}, [e, t]);
}
//#endregion
//#region src/locale/chartLanguageMenu.ts
function ve(e, t) {
	let { align: n = "right", icon: r, locales: i, onSelect: a, title: o = "", tooltip: s } = t, c = e.createDropdown({
		align: n,
		icon: r,
		items: i.map((e) => ({
			title: e.name,
			onSelect: () => a(e)
		})),
		title: o,
		...s ? { tooltip: s } : {}
	});
	return { dispose: () => {
		c.then((e) => e.remove()).catch(() => void 0);
	} };
}
//#endregion
//#region src/locale/createChartTranslate.ts
function q(e) {
	let t = E.getFixedT(e), n = {
		Ticks: t("points"),
		Units: t("lots")
	};
	return (e) => n[e] ?? null;
}
//#endregion
//#region src/locale/useChartLocale.ts
function ye(e) {
	return o(() => ({
		translate: q(e),
		widgetLocale: m(e)
	}), [e]);
}
//#endregion
//#region src/page-zoom/blockPageZoom.ts
var be = ["gesturestart", "gesturechange"];
function xe(e) {
	e.preventDefault();
}
function Se(e) {
	for (let t of be) e.addEventListener(t, xe, { passive: !1 });
}
//#endregion
//#region src/resolution/resolutions.ts
var Ce = "60", we = [
	"1",
	"2",
	"3",
	"5",
	"10",
	"15",
	"30",
	"60",
	"120",
	"180",
	"240",
	"360",
	"480",
	"720",
	"1D",
	"1W",
	"1M"
], Te = {
	1: 1,
	2: 2,
	3: 3,
	5: 5,
	10: 10,
	15: 15,
	30: 30,
	60: 60,
	120: 120,
	180: 180,
	240: 240,
	360: 360,
	480: 480,
	720: 720,
	"1D": 1440,
	"1W": 10080,
	"1M": 43200
};
//#endregion
//#region src/symbols/symbolMapper.ts
function Ee(e, t) {
	let { exchange: n, iconsSource: r, sessionFallback: i, supportedResolutions: a } = t;
	return e.map((e) => ({
		name: e.symbol,
		ticker: e.symbol,
		currency_code: e.currency_base,
		original_currency_code: e.currency_base,
		visible_plots_set: "ohlcv",
		delay: 0,
		format: "price",
		volume_precision: 0,
		description: e.description,
		type: e.group,
		exchange: n,
		timezone: "Etc/UTC",
		listed_exchange: n,
		has_daily: !0,
		has_empty_bars: !1,
		has_weekly_and_monthly: !0,
		has_volume: !0,
		supported_resolutions: a,
		data_status: "streaming",
		session: e.watchlist_sessions || i,
		library_custom_fields: {
			digits: e.digits,
			originalSessions: e.sessions,
			calc_mode: e.calc_mode,
			contract_size: e.contract_size,
			currency_base: e.currency_base,
			currency_margin: e.currency_margin,
			currency_profit: e.currency_profit,
			volume_max_lots: e.volume_max_lots,
			volume_min_lots: e.volume_min_lots,
			volume_step_lots: e.volume_step_lots,
			volume_limit_lots: e.volume_limit_lots
		},
		minmov: 1,
		minmov2: 0,
		fractional: !1,
		pricescale: 10 ** e.digits,
		has_intraday: !0,
		logo_urls: De(r, e),
		exchange_logo: "/logo.png"
	}));
}
function De(e, t) {
	return t.currency_base === t.currency_profit ? [h(e, t.symbol)] : [h(e, t.currency_base), h(e, t.currency_profit)];
}
//#endregion
//#region src/theme/applyThemeToSavedChart.ts
function Oe(e, t) {
	let n = J(e);
	if (!n || typeof n.content != "string") return e;
	let r = J(n.content);
	if (!r || !Array.isArray(r.charts)) return e;
	let i = !1;
	for (let e of r.charts) i = ke(e, t) || i;
	return i ? JSON.stringify({
		...n,
		content: JSON.stringify(r)
	}) : e;
}
function ke(e, t) {
	if (!O(e) || !O(e.chartProperties)) return !1;
	let { paneProperties: n, scalesProperties: r } = e.chartProperties;
	if (!O(n) || z(n)) return !1;
	let { background: i, textColor: a } = A[t], o = !1;
	return (n.background !== i || n.backgroundType !== "solid") && (n.background = i, n.backgroundType = "solid", o = !0), O(r) && typeof r.textColor == "string" && r.textColor !== a && I(r.textColor) && (r.textColor = a, o = !0), o;
}
function J(e) {
	try {
		let t = JSON.parse(e);
		return O(t) ? t : null;
	} catch {
		return null;
	}
}
//#endregion
//#region src/theme/chartThemeToggle.ts
function Ae(e, t) {
	let { align: n = "right", icons: r, onToggle: i, title: a } = t, o = e.createButton({
		align: n,
		useTradingViewStyle: !1
	}), s = o.ownerDocument.createElement("div"), c = t.theme, l = () => {
		s.innerHTML = r[c];
	}, u = () => i(c === "dark" ? "light" : "dark");
	return o.dataset.internalAllowKeyboardNavigation = "true", o.classList.add("apply-common-tooltip"), o.setAttribute("title", a), o.style.cursor = "pointer", Object.assign(s.style, {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	}), o.append(s), o.addEventListener("click", u), l(), {
		dispose: () => {
			o.removeEventListener("click", u), o.remove();
		},
		setTheme: (e) => {
			c = e, l();
		}
	};
}
//#endregion
//#region src/theme/chartState.ts
var je = 3e3;
function Y(e) {
	return new Promise((t) => {
		let n = setTimeout(() => t(null), je);
		try {
			e.save((e) => {
				clearTimeout(n), t(e);
			});
		} catch {
			clearTimeout(n), t(null);
		}
	});
}
//#endregion
//#region src/theme/chartStyles.ts
var Me = "mainSeriesProperties";
function Ne(e) {
	return ("charts" in e && Array.isArray(e.charts) ? e.charts : []).map(Ie);
}
function Pe(e) {
	for (let t of e) {
		let e = L(t["paneProperties.background"]);
		if (e) return e;
	}
	return null;
}
function Fe(e, t) {
	let n = {};
	for (let [r, i] of Object.entries(e)) !ze(i, t[r]) && !Re(r, i) && (n[r] = i);
	return n;
}
function Ie(e) {
	return O(e) ? {
		...X(e.chartProperties),
		...X(Le(e), Me)
	} : {};
}
function Le(e) {
	let t = (Array.isArray(e.panes) ? e.panes : []).flatMap((e) => O(e) && Array.isArray(e.sources) ? e.sources : []).find((e) => O(e) && e.type === "MainSeries");
	return O(t) ? t.state : void 0;
}
function X(e, t = "", n = {}) {
	if (O(e) && !Array.isArray(e)) for (let [r, i] of Object.entries(e)) X(i, t ? `${t}.${r}` : r, n);
	else t && (n[t] = e);
	return n;
}
function Re(e, t) {
	return typeof t == "string" ? e === "paneProperties.background" ? F(t) : e === "scalesProperties.textColor" && I(t) : !1;
}
function ze(e, t) {
	return JSON.stringify(e) === JSON.stringify(t);
}
//#endregion
//#region src/theme/applyChartTheme.ts
async function Z(e, t) {
	let n = await $(e);
	if (n.length === 0) {
		await Q(e, t);
		return;
	}
	let r = Pe(n) ?? e.getTheme();
	await Q(e, r);
	let i = await $(e);
	t !== r && await Q(e, t), i.length === n.length && Be(e, n, i);
}
async function Q(e, t) {
	await e.changeTheme(t, { disableUndo: !0 }), e.applyOverrides(R(t));
}
async function $(e) {
	let t = await Y(e);
	return t ? Ne(t) : [];
}
function Be(e, t, n) {
	t.forEach((t, r) => {
		let i = Fe(t, n[r]);
		Object.keys(i).length > 0 && e.chart(r).applyOverrides(i);
	});
}
//#endregion
//#region src/theme/chartThemeController.ts
function Ve(e) {
	let t = null, n = !1, r = !1, i = Promise.resolve(), a = async () => {
		let i = t, a = n, o = He(e);
		if (n = !1, !(r || i === null || o === null)) try {
			(i !== o || a && await Ue(e, i)) && !r && await Z(e, i);
		} catch (e) {
			r || console.warn("Chart theme switch failed", e);
		}
	}, o = (e, r) => (t = e, n ||= r, i = i.then(a), i);
	return {
		dispose: () => {
			r = !0;
		},
		repaint: (e) => o(e, !0),
		setTheme: (e) => o(e, !1)
	};
}
function He(e) {
	try {
		return e.getTheme();
	} catch {
		return null;
	}
}
async function Ue(e, t) {
	let n = await Y(e);
	return n !== null && B(n, t);
}
//#endregion
//#region src/theme/useChartThemeSync.ts
function We(e, t) {
	let n = s(null), r = s(!1);
	i(() => {
		if (!e) return;
		let t = Ve(e);
		return n.current = t, r.current = !0, () => {
			t.dispose(), n.current = null;
		};
	}, [e]), i(() => {
		let i = n.current;
		!e || !i || (r.current ? (r.current = !1, i.repaint(t)) : i.setTheme(t));
	}, [e, t]);
}
//#endregion
//#region src/websockets-abstract/WebSocketManager.ts
var Ge = {
	initialDelayMs: 200,
	maxDelayMs: 5e3
}, Ke = class {
	connection;
	subscriptions = /* @__PURE__ */ new Map();
	constructor(e) {
		this.connection = g({
			key: e,
			url: () => this.getEndpoint(),
			parse: (e) => this.parse(e),
			reconnect: Ge
		});
	}
	connect() {
		this.connection.connect();
	}
	subscribe(e) {
		this.subscriptions.has(e) || this.subscriptions.set(e, this.connection.subscribe(e));
	}
	unsubscribe(e) {
		this.subscriptions.get(e)?.(), this.subscriptions.delete(e);
	}
	onStatusChange(e) {
		return this.connection.onStatusChange(e);
	}
	disconnect() {
		this.connection.disconnect();
	}
};
//#endregion
export { k as CHART_BRAND_COLOR, A as CHART_THEME_COLORS, pe as GlobalLoading, he as LoadError, Ke as WebSocketManager, Oe as applyThemeToSavedChart, Se as blockPageZoom, ve as createChartLanguageMenu, Ae as createChartThemeToggle, q as createChartTranslate, Ce as defaultSelectedResolution, R as getChartThemeOverrides, Ee as mapSymbols, Te as resolutionsMapper, we as supportedResolutions, _ as updateDocumentTitle, ye as useChartLocale, We as useChartThemeSync, _e as useGlobalLoading };
